import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Box, CssBaseline, Typography } from '@mui/material';
import http from './commonFunctions/httpClient';
import { OrderSummary } from './Pages/OrderSummary/OrderSummary';
import { RestaurantHeader } from './Pages/MenuLuxPos/RestaurantHeader';
import RestaurantSidebar from './Pages/MenuLuxPos/RestaurantSidebar';
import OrderDetails from './Pages/MenuLuxPos/OrderDetails';
import {MenuItemCard} from './Pages/MenuLuxPos/MenuItemCard';
import RightSidebar from './Pages/MenuLuxPos/Menubar';
import { MainLayout } from './Pages/MainLayout/MainLayout';
import HeaderEazee from './Pages/HeaderEazee/HeaderEazee';
import MainContent from './Pages/OrderTypeTransactions/MainContentEzee';
import { Login } from './Pages/LogIn/LogIn';
import { Bar } from './Pages/DineIn/DineIn';
import { DineInNewKotHeader } from './Pages/TakeAway/DineInNewKotHeader';
import { AmountPaid } from './Pages/Amount/AmountPaid';
import { ItemSearch } from './Pages/TakeAway/ItemSearch';
import { ReceiptModification } from './Pages/TakeAway/ReceiptModification';
import { Phone } from './Pages/Delivery/GuestSearch/Phone';
import { GuestSearch } from './Pages/Delivery/GuestSearch/GuestSearch';
import { GuestFolioSearch } from './Pages/AdvanceOrder/GuestFolioSearch';
import { GuestSearchOrder } from './Pages/AdvanceOrder/GuestSearch';
import { GuestInformation } from './Pages/AdvanceOrder/GuestInformation';
import { GuestSearchInfo } from './Pages/AdvanceOrder/GuestSearchInfo';
import { ReceiptList } from './Pages/Receipt/ReceiptList';
import { ItemOnHold } from './Pages/HoldItem/ItemOnHold';
import { CallCenterOrderList } from './Pages/CallCenter/CallCenterOrderList';
import { AdvanceOrderList } from './Pages/AdvanceList/AdvanceOrderList';
import { DriverRouting } from './Pages/NewTrip/DriverRouting';
import { CheckInDriver } from './Pages/CheckIn/CheckInDriver';
import { DeliveryStatus } from './Pages/DeliveryStatus/DeliveryStatus';
import { Report } from './Pages/Report/Report';
import { Message } from './Pages/Messages/Message';
import { ReservationList } from './Pages/OrderTypeTransactions/OthersOperation/ReservationList';
import { WaitingList } from './Pages/OrderTypeTransactions/OthersOperation/WaitingList';
import { OrderItem } from './Pages/OrderTypeTransactions/OthersOperation/OrderItem';
import { ReservationInformation } from './Pages/OrderTypeTransactions/OthersOperation/ReservationInformation';
import { PayOuts } from './Pages/OrderTypeTransactions/OthersOperation/PayOuts';
import { PayOut } from './Pages/OrderTypeTransactions/OthersOperation/PayOut';
import { MiscSales } from './Pages/OrderTypeTransactions/OthersOperation/MiscSales';
import { MiscSale } from './Pages/OrderTypeTransactions/OthersOperation/MiscSale';
import { AccountListing } from './Pages/OrderTypeTransactions/OthersOperation/AccountListing';
import { PaymentPosting } from './Pages/OrderTypeTransactions/OthersOperation/PaymentPosting';
import { PaymentList } from './Pages/OrderTypeTransactions/OthersOperation/PaymentList';
import { TakeTable } from './Pages/OrderTypeTransactions/OthersOperation/TakeTable';
import { TranserTable } from './Pages/OrderTypeTransactions/OthersOperation/TransferTable';
import { Catering } from './Pages/Catering/Catering';
import { OrderHistory } from './Pages/Delivery/GuestSearch/OrderHistory';
import { ExportedOrderList } from './Pages/CallCenter/ExportedOrder';
import { TableView } from './Pages/OrderTypeTransactions/OthersOperation/TableView';
import { Settings } from './Pages/Settings/Settings';
import DashboardPage from './Backend/BackendHome/BackEndHome';


const App: React.FC = () => {
  const [token, setToken] = useState<string | null>(localStorage.getItem('token'));

  useEffect(() => {
    if (token) {
      http.setAuthToken(token);
    }
  }, [token]);

  const handleLogin = (newToken: string) => {
    setToken(newToken);
    localStorage.setItem('token', newToken);
    http.setAuthToken(newToken);
  };

  const handleLogout = () => {
    setToken(null);
    localStorage.removeItem('token');
    http.setAuthToken(null);
  };
  const [selectedMenu, setSelectedMenu] = useState<string>(''); // Track the selected menu

  const handleMenuSelect = (menu: string) => {
    setSelectedMenu(`Menu > ${menu}`); // Update the selected path when a menu item is clicked
  };
  return (
    <Router>
      <CssBaseline />
      
      
      <Routes>
      <Route
          path="/login"
          element={
            <div>
              <Login onLogin={handleLogin} />
            </div>
          }
        />        
        
        <Route path='/ordersummary' element={<OrderSummary />} />
        <Route path='/backendhome' element={<DashboardPage />} />

        <Route path='/main' element={<MainLayout selectedMenu={selectedMenu} handleMenuSelect={handleMenuSelect}/>}/>
        <Route
          path="*"
          element={
            <div>
              <HeaderEazee/>
              <Routes>
                <Route path="/" element={<MainContent />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/dinein" element={<Bar />} />
                <Route path="/takeaway" element={<DineInNewKotHeader />} />
                <Route path="/amount" element={<AmountPaid />} />
                <Route path="/itemsearch" element={<ItemSearch />} />
                <Route path="/modification" element={<ReceiptModification />} />
                <Route path="/delivery" element={<Phone/>} />
                <Route path="/catering" element={<Catering/>} />
                <Route path="/guestsearch" element={<GuestSearch/>} />
                <Route path="/orderhistory" element={<OrderHistory/>} />
                <Route path="/guestfolio" element={<GuestFolioSearch/>} />
                <Route path="/guestsearchorder" element={<GuestSearchOrder/>} />
                <Route path="/guestinformation" element={<GuestInformation/>} />
                <Route path="/guestsearchinfo" element={<GuestSearchInfo/>} />
                <Route path="/receiptlist" element={<ReceiptList/>} />
                <Route path="/holditem" element={<ItemOnHold/>} />
                <Route path="/callcenter" element={<CallCenterOrderList/>} />
                <Route path="/exportedorder" element={<ExportedOrderList/>} />
                <Route path="/advancelist" element={<AdvanceOrderList/>} />
                <Route path="/newtrip" element={<DriverRouting/>} />
                <Route path="/checkin" element={<CheckInDriver/>} />
                <Route path="/status" element={<DeliveryStatus/>} />
                <Route path="/report" element={<Report/>} />
                <Route path="/message" element={<Message/>} />
                <Route path="/reservationlist" element={<ReservationList/>} />
                <Route path="/tableview" element={<TableView/>} />
                <Route path="/waitinglist" element={<WaitingList/>} />
                <Route path="/reservationinformation" element={<ReservationInformation/>} />
                <Route path="/orderitem" element={<OrderItem/>} />
                <Route path="/payouts" element={<PayOuts/>} />
                <Route path="/payout" element={<PayOut/>} />
                <Route path="/miscsales" element={<MiscSales/>} />
                <Route path="/miscsale" element={<MiscSale/>} />
                <Route path="/accountlisting" element={<AccountListing/>} />
                <Route path="/paymentposting" element={<PaymentPosting/>} />
                <Route path="/paymentlist" element={<PaymentList/>} />
                <Route path="/taketable" element={<TakeTable/>} />
                <Route path="/transfertable" element={<TranserTable/>} />



                </Routes>
            </div>
          }
        />
      </Routes>
      </Router>
  );
};

export default App;
